module.exports = __webpack_public_path__ + "static/media/产品介绍4.1220172e.png";